import {TabKeys} from "../constants";
import {PANEL_TYPES} from "../../constants";
import TemplateView from "../../../TemplateView"
import {LicenseInfo} from "../../../constants"
import TabsController from '../../TabsController'

export default class UserPanelContent extends TemplateView {
    constructor({
        $headerTabs,
        accountSettings,
        permissions,
        tabSwitchedCallback = (tabKey) => {},
    }) {
        super(null);

        this.params = {
            $headerTabs
        }

        this.components = {
            accountSettings,
            permissions
        }

        this.type = PANEL_TYPES.EDIT_USER;

        this.onHideCb = () => {}
        this.tabSwitchedCallback = tabSwitchedCallback

        this.updateOnInit = true

        this.state = {
            currentTabKey: null
        }
        this.onStatePropertyChanged('currentTabKey', this._handleTabSwitched)
    }

    templateHtml() {
        return '<div class="content"/>'
    }

    afterRender() {
        this.$el.toggleClass("showIntegrationMarks", LicenseInfo.isApActive)

        this.components.accountSettings.init(this.getEl());
        this.components.permissions.init(this.getEl());

        let tabs = new Map([
            [TabKeys.ACCOUNT_SETTINGS, this.components.accountSettings],
            [TabKeys.PERMISSIONS, this.components.permissions],
        ])

        tabs.forEach(($tab, tabKey) => {
            $tab.hide()
        })

        this.tabsController = new TabsController({
            tabs: tabs,
        }).init()

        this.buttons = new Map([
            [TabKeys.ACCOUNT_SETTINGS, this.params.$headerTabs.$accountSettingsTab],
            [TabKeys.PERMISSIONS, this.params.$headerTabs.$permissionsTab],
        ])

        this.buttons.forEach(($button, key) => {
            $button.click(() => this.tabSwitchedCallback(key))
        })
    }

    _handleTabSwitched = (selectedKey, previousKey) => {
        this.tabsController.setState({selectedTabKey: selectedKey})

        if (previousKey) this.buttons.get(previousKey).toggleClass('selected', false)
        this.buttons.get(selectedKey).toggleClass('selected', true)
    }

    onScroll() {
        this.components.accountSettings.onScroll();
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/editPanel/UserPanelContent.js